// extracted by mini-css-extract-plugin
export default {"fieldsetLegend":"FormFieldset_fieldsetLegend__Jmnmc"};